module.exports = __webpack_public_path__ + "img/arrow_down_black_16px.d6555afa.svg";